import { lazy } from 'react';

const LazyFlowList = lazy(() => import('./flow-list'));
export default LazyFlowList;
